import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {
  BokkzJrLogic, EnrichGrondslagByIdResult,
  FormattedExplanationPolicy,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SelectFormControlItem, SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {ButtonConfiguration, SharedUiButtonModule} from '@snelstart/ui-button';
import {SharedUiDialogModule} from '@snelstart/ui-dialog';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {CommonModule} from '@angular/common';
import {SharedUiTooltipTriggerModule} from "@snelstart/ui-tooltip-trigger";
import {Observable, tap} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-formattedexplanationpolicy',
  templateUrl: './spec-formattedexplanationpolicy.component.html',
  imports: [
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule,
    SharedUiTooltipTriggerModule
  ],
  styleUrls: ['./spec-formattedexplanationpolicy.component.scss']
})
export class SpecFormattedexplanationpolicyComponent implements OnChanges {

  @Input({ required: true }) public title = <string>{};
  @Input({ required: true }) public input!: FormGroup;
  @Input({ required: true }) public policyId!: string;
  @Input() public dialogVisible = false;
  @Output() public dialogVisibleChange = new EventEmitter<boolean>();
  @Output() public inputChange = new EventEmitter<FormGroup>();
  public inputFg = {} as FormGroup;
  public readonly = true;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: 'Ja'},
    {value: false, label: 'Nee'},
  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService,
    public bokkzJrLogic: BokkzJrLogic,
    private fb: FormBuilder) {
    this.inputFg = this.fb.group<FormattedExplanationPolicy>({
      value: null as unknown as string,
      includeInKvkReport: false,
      selected: null as unknown as boolean,
      customPolicy: false,
    })
  }

  ngOnChanges(): void {
    if (!this.input) return;

    this.inputFg.patchValue(this.input.getRawValue(), {emitEvent: false})
    this.readonly = !this.inputFg.value.customPolicy
  }

  submit() {
    this.input.patchValue(this.inputFg.getRawValue(), {emitEvent: false})
    this.inputChange.emit(this.input)
    this.dialogVisibleChange.emit(false)
  }

  cancel() {
    this.dialogVisibleChange.emit(false);
  }

  setCustomPolicy() {
    this.readonly = false;
    this.inputFg.patchValue({customPolicy: true})
  }

  setDefaultPolicy = ButtonConfiguration.create({
    onClick: () =>
      this.getEnrichedGrondsladById().pipe(
        tap(result => {
          //alleen value patchen als er een juiste response is, value kan dan overigens gewoon leeg / undefined zijn
          if (result.length > 0) {
            const value = result[0].value;
            this.inputFg.patchValue({value: value});
          }

          this.inputFg.patchValue({customPolicy: false});
          this.readonly = true;
        })
      )
  });

  getEnrichedGrondsladById(): Observable<EnrichGrondslagByIdResult[]> {
    const ids: string[] = [this.policyId];

    return this.bokkzJrLogic.enrichPoliciesByIds(ids);
  }

  /** Tooltips  */
  public tooltips = {
    customPolicy: {
      icon: 'circle-info',
      tooltip: 'Let op: bij gebruik van een eigen grondslag wordt deze waarde niet meer overschreven bij het opnieuw inlezen van de administratie',
      placement: 'right',
    },
    defaultPolicy: {
      icon: 'circle-info',
      tooltip: 'Let op: bij gebruik van de standaard grondslag zal de eigen grondslag worden overschreven door de standaard (of lege) waarde',
      placement: 'right',
    }
  } as const;
}
